import React from 'react';
import PropTypes from 'prop-types';
import LinearProgress from '@mui/material/LinearProgress';

const AppProgressBar = (props) => {
  const {
    thickness = 3,
    variant = 'determinate',
    value,
    pathColor = '#F5F6FA',
    activeColor = '#00905F',
    borderRadius = 10,
  } = props;
  return (
    <div style={{height: thickness, textAlign: 'center'}}>
      <LinearProgress
        variant={variant}
        value={value}
        sx={{
          height: thickness,
          border: 0.5,
          borderColor: '#DCDCDC',
          borderRadius: borderRadius,
          backgroundColor: pathColor,
          '& .MuiLinearProgress-bar': {
            backgroundColor: activeColor,
          },
        }}
      />
    </div>
  );
};

AppProgressBar.propTypes = {
  thickness: PropTypes.number,
  borderRadius: PropTypes.number,
  pathColor: PropTypes.string,
  activeColor: PropTypes.string,
  variant: PropTypes.oneOf(['buffer', 'determinate', 'indeterminate', 'query']),
  value: PropTypes.number,
};

export default AppProgressBar;
